import { MAX_HISTORICAL_EMAILS } from '@/constants/store/constants';

// Adds email payload data from event to vuex store
const addEmailData = (state, email) => {
  const index = state.active.findIndex(e => e.interactionId === email.interactionId);
  if (index >= 0) {
    const existingEmail = state.active.splice(index, 1)[0];
    state.active.push({
      ...email,
      outgoingEmailData: {
        ...email.outgoingEmailData,
        to: existingEmail.outgoingEmailData.to
      }
    });
  } else {
    state.active.push(email);
  }
};

// Removes email data from vuex store
const deleteEmailInteraction = (state, interactionId) => {
  let index = state.active.findIndex(email => email.interactionId === interactionId);
  if (index >= 0) {
    state.active.splice(index, 1);
  } else {
    index = state.history.findIndex(email => email.interactionId === interactionId);
    if (index >= 0) {
      state.history.splice(index, 1);
    }
  }
};

// Moves an email interaction to history
const moveEmailToHistory = (state, event) => {
  const { interactionId } = event;
  const index = state.active.findIndex(email => email.interactionId === interactionId);
  if (index >= 0) {
    const email = state.active.splice(index, 1)[0];
    state.history.push(email);
    if (state.history.length > MAX_HISTORICAL_EMAILS) {
      state.history = state.history.slice(-MAX_HISTORICAL_EMAILS);
    }
  }
};

// Updates email response body with the information coming from quill editor
const updateEmailResponseBody = (state, { interactionId, content }) => {
  const emailIndex = state.active.findIndex(email => email.interactionId === interactionId);
  if (emailIndex === -1) {
    return;
  }

  const existingEmail = state.active[emailIndex];
  existingEmail.outgoingEmailData.body = content;
  state.active.splice(emailIndex, 1, existingEmail);
};

const updateCcEmails = (state, { emails, interactionId }) => {
  const emailIndex = state.active.findIndex(email => email.interactionId === interactionId);
  if (emailIndex === -1) {
    return;
  }

  const existingEmail = state.active[emailIndex];
  existingEmail.outgoingEmailData.cc = emails;
  state.active.splice(emailIndex, 1, existingEmail);
};

const updateToEmails = (state, { emails, interactionId }) => {
  const emailIndex = state.active.findIndex(email => email.interactionId === interactionId);
  if (emailIndex === -1) {
    return;
  }

  const existingEmail = state.active[emailIndex];
  existingEmail.outgoingEmailData.to = emails;
  state.active.splice(emailIndex, 1, existingEmail);
};

const updateBccEmails = (state, { emails, interactionId }) => {
  const emailIndex = state.active.findIndex(email => email.interactionId === interactionId);
  if (emailIndex === -1) {
    return;
  }

  const existingEmail = state.active[emailIndex];
  existingEmail.outgoingEmailData.bcc = emails;
  state.active.splice(emailIndex, 1, existingEmail);
};

const updateRequiredBccEmails = (state, { emails, interactionId }) => {
  const emailIndex = state.active.findIndex(email => email.interactionId === interactionId);
  if (emailIndex === -1) {
    return;
  }

  const existingEmail = state.active[emailIndex];
  existingEmail.outgoingEmailData.requiredBcc = emails;
  state.active.splice(emailIndex, 1, existingEmail);
};

const updateSubject = (state, { subject, interactionId }) => {
  const emailIndex = state.active.findIndex(email => email.interactionId === interactionId);
  if (emailIndex === -1) {
    return;
  }

  const existingEmail = state.active[emailIndex];
  existingEmail.outgoingEmailData.subject = subject;
  state.active.splice(emailIndex, 1, existingEmail);
};

const setOutgoingEmailCreationTime = (state, { interactionId, date }) => {
  const emailIndex = state.active.findIndex(email => email.interactionId === interactionId);
  if (emailIndex === -1) {
    return;
  }

  const existingEmail = state.active[emailIndex];
  existingEmail.outgoingEmailData.creationTime = date;
  state.active.splice(emailIndex, 1, existingEmail);
};

const setOutgoingEmailAsCanceled = (state, interactionId) => {
  const emailIndex = state.active.findIndex(email => email.interactionId === interactionId);
  if (emailIndex === -1) {
    return;
  }

  const existingEmail = state.active[emailIndex];
  existingEmail.outgoingEmailData.canceled = true;
  state.active.splice(emailIndex, 1, existingEmail);
};

const setSignatureCursorPosition = (state, { interactionId, signatureIndex }) => {
  const emailIndex = state.active.findIndex(email => email.interactionId === interactionId);
  if (emailIndex === -1) {
    return;
  }

  const existingEmail = state.active[emailIndex];
  existingEmail.outgoingEmailData.signatureIndex = signatureIndex;
  state.active.splice(emailIndex, 1, existingEmail);
};

const addOutgoingAttachments = (state, { interactionId, attachments }) => {
  const emailIndex = state.active.findIndex(activeEmail => activeEmail.interactionId === interactionId);
  if (emailIndex === -1) {
    return;
  }

  const existingEmail = state.active[emailIndex];
  existingEmail.outgoingEmailData.attachments = [...existingEmail.outgoingEmailData.attachments, ...attachments];
  state.active.splice(emailIndex, 1, existingEmail);
};

const removeOutgoingAttachment = (state, { interactionId, id }) => {
  const emailIndex = state.active.findIndex(activeEmail => activeEmail.interactionId === interactionId);
  if (emailIndex === -1) {
    return;
  }

  const existingEmail = state.active[emailIndex];
  const attachments = [...existingEmail.outgoingEmailData.attachments];

  const attachmentIndex = attachments.findIndex(attachment => attachment.id === id);
  if (attachmentIndex === -1) {
    return;
  }
  attachments.splice(attachmentIndex, 1);
  existingEmail.outgoingEmailData.attachments = [...attachments];
  state.active.splice(emailIndex, 1, existingEmail);
};

const clearAttachments = (state, { interactionId }) => {
  const emailIndex = state.active.findIndex(activeEmail => activeEmail.interactionId === interactionId);
  if (emailIndex === -1) {
    return;
  }

  const existingEmail = state.active[emailIndex];
  existingEmail.outgoingEmailData.attachments.splice(0, existingEmail.outgoingEmailData.attachments.length);
  state.active.splice(emailIndex, 1, existingEmail);
};

const updateValidAttachments = (state, { interactionId, attachmentsToUpdate }) => {
  const emailIndex = state.active.findIndex(activeEmail => activeEmail.interactionId === interactionId);
  if (emailIndex === -1) {
    return;
  }

  const existingEmail = state.active[emailIndex];
  const attachments = [...existingEmail.outgoingEmailData.attachments];
  attachmentsToUpdate.forEach(attachment => {
    const attachmentIndex = attachments.findIndex(a => a.id === attachment.id);
    if (attachmentIndex === -1) {
      return;
    }

    attachments[attachmentIndex] = attachment;
    existingEmail.outgoingEmailData.attachments.splice(attachmentIndex, 1, attachment);
  });
  state.active.splice(emailIndex, 1, existingEmail);
};

const updateFromEmail = (state, { interactionId, fromEmail }) => {
  const emailIndex = state.active.findIndex(email => email.interactionId === interactionId);
  if (emailIndex === -1) {
    return;
  }

  const existingEmail = state.active[emailIndex];
  existingEmail.outgoingEmailData.from = fromEmail;
  state.active.splice(emailIndex, 1, existingEmail);
};

export default {
  addEmailData,
  moveEmailToHistory,
  deleteEmailInteraction,
  updateEmailResponseBody,
  updateCcEmails,
  updateToEmails,
  updateBccEmails,
  updateSubject,
  setOutgoingEmailCreationTime,
  setOutgoingEmailAsCanceled,
  setSignatureCursorPosition,
  addOutgoingAttachments,
  removeOutgoingAttachment,
  clearAttachments,
  updateValidAttachments,
  updateFromEmail,
  updateRequiredBccEmails
};
